/**
 * Studio54 Version
 * Format: Year.Month.Day-T.Hour.Minute
 */
export const APP_VERSION = '2026.03.17'
export const APP_NAME = 'Studio54'
export const APP_DESCRIPTION = 'Music Acquisition System'
